export const RESPONDENT_STATUS = {
    MEDICAL_CLEARED: "Medical Cleared",
};
export const RESPONDENT_VALID_CUSTOM_FIELDS = [
    "custom01",
    "custom02",
    "custom03",
    "custom04",
    "custom05",
    "custom06",
    "custom07",
    "custom08",
    "custom09",
    "custom10",
];
//# sourceMappingURL=respondent.js.map